// src/config/config.ts
import domain1 from './domain/domain_1';
import domain5252slot from './domain/5252slot';
import {AppConfig} from './AppConfig';
import Util from "@/Master/Util";

// 创建配置映射
const configMap: Record<string, AppConfig> = {
    'test.com': domain1,
    'b.com': domain5252slot,
};

// 定义 getConfig 函数，返回类型为 Config
export const getConfig = (): AppConfig => {
    const domain: string = Util.isWindow ? window.location.hostname:'';
    return configMap[domain] || domain1; // 返回对应的配置，如果没有匹配则返回 domain1
};

// 直接返回 confJson 的结果
export const confJson: AppConfig = getConfig();
